module.exports = __webpack_public_path__ + "media/time.a473ece7.mp3";